import React, { useContext } from 'react';
import { forBrands, useTheme, getFontWeight } from '@core-ui/react-stitch';
import { useLocalize } from '@core-ui/localization-provider';
import { FeatureFlagsContext } from '@core-ui/feature-flags';
import { PageDataContext } from '../../providers/page-data-provider/index';

const ItemCountContainer = (): JSX.Element => {
  const { localize } = useLocalize();
  const { productGroups } = useContext(PageDataContext);
  const { enabledFeatures } = useContext(FeatureFlagsContext);

  const itemCount = productGroups[0].products.length;
  const isBRColorChange2023 = enabledFeatures['br-colors-2023'];

  const theme = useTheme();
  const styles = forBrands(theme, {
    br: {
      fontSize: '0.875rem',
      ...getFontWeight('regular'),
      color: isBRColorChange2023 ? '#000000' : theme.color.b2,
      textTransform: 'capitalize',
      ...theme.brandFontAlt,
    },
    brfs: {
      fontSize: '0.875rem',
      ...getFontWeight('regular'),
      color: isBRColorChange2023 ? '#000000' : theme.color.b2,
      textTransform: 'capitalize',
      ...theme.brandFontAlt,
    },
    default: {
      ...theme.brandFont,
      color: theme.color.g2,
    }
  });

  const ariaLabelText = localize(
    itemCount > 1
      ? 'left_rail.item_count_aria_label_plural'
      : 'left_rail.item_count_aria_label',
    { itemCount }
  );
  const itemCountText = localize(
    itemCount > 1
      ? 'left_rail.item_count_text_plural'
      : 'left_rail.item_count_text',
    { itemCount }
  );

  return (
    <div
      className="item-count-container"
      data-testid="item-count-container"
      aria-atomic="true"
      aria-label={ariaLabelText}
      aria-live="polite"
      css={[styles]}
    >
      {itemCountText}
    </div>
  );
};

export default ItemCountContainer;
